// Mirror Causable.Api.Data.Enum.ErrorTypes 910-913; the messages match the English copy in their error categories.
export const UNPAUSE_GAME_NO_COVERING_LICENCE_ERROR_TYPE = 910;
export const UPDATE_ENDED_ON_OUTSIDE_LICENCE_ERROR_TYPE = 911;

export const UNPAUSE_GAME_NO_COVERING_LICENCE_MESSAGE =
  'This game has no lottery licence covering today. Add the licence and the game resumes on its own.';
export const UPDATE_ENDED_ON_OUTSIDE_LICENCE_MESSAGE =
  'The lottery licence this draw runs under does not cover that date. A draw cannot be moved past its licence\'s last day.';
